import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { Asset } from "@/types/assets";

import { getAsset } from "./assetsApi";

export default function useBatchGetAssets(
  options?: Omit<UseMutationOptions<Asset[], Error, string[]>, "mutationFn">
) {
  return useMutation({
    mutationFn: async (assetIds: string[]) => {
      const promises = assetIds.map((id) => getAsset(id));
      return Promise.all(promises);
    },
    ...options
  });
}
